module.exports = __webpack_public_path__ + "img/20.451607f2.jpg";